import { server } from "./axios";

export interface OtpRequest {
  phone: string;
  iin: string;
}

export class Token {
  access_token?: string;
  expires_in?: number;
  token_type?: string;
}

export class AuthOtpController {
  async sendOtp(request?: OtpRequest): Promise<any> {
    console.log("submit otp");
    return await server.postFree(
      `/send-otp`,
      {
        ...request,
      },
      {
        baseURL: "https://dbp.bcc.kz/v1/dbp/deferral",
      }
    );
  }

  async confirmOtp(value: string, token: string): Promise<any> {
    console.log("confirm otp");
    return await server.postFree(
      `/verify-user`,
      {
        value,
      },
      {
        baseURL: "https://dbp.bcc.kz/v1/dbp/deferral",
        headers: {
          Authorization: token
        }
      }
    );
  }
}
